import React from "react";
import "../../assets/styling.css";

const Loader = ({ fixed = true }) => {
  return (
    <div
      style={{
        position: fixed ? "fixed" : "relative",
        top: fixed ? 0 : "auto",
        left: fixed ? 0 : "auto",
        right: fixed ? 0 : "auto",
        bottom: fixed ? 0 : "auto",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%",
      }}
    >
      <div className="loader" />
    </div>
  );
};

export default Loader;
